// extracted by mini-css-extract-plugin
export var infoRow = "_uq-2";
export var labelContainer = "_uq-0";
export var rightInfo = "_uq-1";